import React from "react";

interface AgreementPdfViewerProps {
  pdfUrl: string | null | undefined;
  title: string;
  emptyMessage: string;
}

const AgreementPdfViewer: React.FC<AgreementPdfViewerProps> = ({
  pdfUrl,
  title,
  emptyMessage,
}) => {
  if (pdfUrl) {
    return (
      <iframe
        title={title}
        src={pdfUrl}
        className="h-[min(55dvh,520px)] w-full rounded-2xl border border-[#E4E4E7] bg-[#525659]"
      />
    );
  }
  return (
    <p className="text-sm text-[#71717A]">{emptyMessage}</p>
  );
};

export default AgreementPdfViewer;
